import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import Select from "react-select";
import { useHeaderTitle } from "~/utils";
import { alertTypeOptions, formatAlertTypeOption } from "~/utils/components/alert_type_badge";
import "./notification_filter.scss";

const IS_ACTIVE_ALL = { value: null, label: "All" };

const isActiveOptions = [
    IS_ACTIVE_ALL,
    { value: true,  label: "Active" },
    { value: false, label: "Inactive" }
];

const NotificationFilter = ({ className, onSubmit = () => {}, onCreate = () => {}, ...props }) => {
    const comp_op = {
        className: ["notification_filters", className].join(" ")
    };

    useHeaderTitle(props.setheader, "Notification Management");

    return (
        <div {...comp_op}>
            <div className="content">
                <Formik
                    initialValues={{
                        type: null,
                        is_active: IS_ACTIVE_ALL,
                        created_by: "",
                        updated_by: ""
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, cmp) => handleSubmit(onSubmit, values, cmp)}
                    onReset={(values, { resetForm, submitForm }) => {
                        resetForm();
                        submitForm();
                    }}
                >
                    {formikProps => {
                        const { values, setFieldValue } = formikProps;
                        return (
                            <Form>
                                <Row>
                                    <Col sm="12" md="6">
                                        <div className="form-group">
                                            <label>Type</label>
                                            <Select
                                                inputId="notification_type"
                                                name="type"
                                                value={values.type}
                                                options={alertTypeOptions}
                                                isClearable
                                                formatOptionLabel={formatAlertTypeOption}
                                                onChange={val => setFieldValue("type", val, false)}
                                            />
                                        </div>
                                    </Col>

                                    <Col sm="12" md="6">
                                        <div className="form-group">
                                            <label>Is Active</label>
                                            <Select
                                                inputId="is_active"
                                                name="is_active"
                                                value={values.is_active}
                                                options={isActiveOptions}
                                                onChange={val => setFieldValue("is_active", val || IS_ACTIVE_ALL, false)}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm="12" md="6">
                                        <div className="form-group">
                                            <label htmlFor="created_by">Create by</label>
                                            <Field
                                                id="created_by"
                                                name="created_by"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </Col>

                                    <Col sm="12" md="6">
                                        <div className="form-group">
                                            <label htmlFor="updated_by">Update by</label>
                                            <Field
                                                id="updated_by"
                                                name="updated_by"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="controls align-items-center justify-content-end">
                                    <Button type="button" color="primary" onClick={onCreate}>
                                        Add New Notification Alert
                                    </Button>

                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear Form
                                    </Button>

                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

const handleSubmit = (submit, obj, { setSubmitting }) => {
    submit({
        ...(obj.type                            ? { type:      obj.type.value      } : {}),
        ...(obj.is_active && obj.is_active.value !== null ? { is_active: obj.is_active.value } : {}),
        ...(obj.created_by ? { created_by: obj.created_by }   : {}),
        ...(obj.updated_by ? { updated_by: obj.updated_by }   : {})
    });
    setSubmitting(false);
};

export default NotificationFilter;
